import React, { useState } from 'react';
import { Button, Tooltip } from 'antd';
import { BugOutlined } from '@ant-design/icons';

import { useAuth } from '../../contexts/AuthContext';
import BugReportModal from './BugReportModal';
import { canUseBugReporter } from './canUseBugReporter';

/**
 * Floating "Report a bug" button. Renders only for LHPH staff who have opted in
 * via Profile → Account Settings → "Bug reporter button" (never for dealers). Click
 * opens the BugReportModal which captures the page via html2canvas before
 * the modal animates in.
 */
const BugReporterButton: React.FC = () => {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);

  if (!user || !user.bugReporterEnabled || !canUseBugReporter(user)) return null;

  return (
    <>
      {/*
       * Wrapper class lets BugReportModal's html2canvas pass skip this
       * button (and its tooltip) so neither the floater nor an open
       * "Report a bug" tooltip ends up baked into the screenshot.
       */}
      <span className="bug-reporter-button-wrap">
        <Tooltip title="Report a bug" placement="left">
          <Button
            type="primary"
            shape="circle"
            icon={<BugOutlined />}
            size="large"
            onClick={() => setOpen(true)}
            style={{
              position: 'fixed',
              right: 24,
              bottom: 24,
              zIndex: 1000,
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
            }}
            aria-label="Report a bug"
          />
        </Tooltip>
      </span>
      <BugReportModal open={open} onClose={() => setOpen(false)} />
    </>
  );
};

export default BugReporterButton;
